import React, {useEffect, useState} from "react";
import { useForm } from "react-hook-form";
import OWASP from "../../../util/owasp";
import WaveButton from "../WaveButton.jsx";
import CONFIGURACIONES from "../../../util/constants";

const AddressModal = ({ show, data, onClose, onSave, showCreate, title, centrosPoblado }) => {
    const { handleSubmit: handleAddressSubmit, register: registerAddress,
            setValue: setAddressValue, formState: { errors: errorsAddress } } = useForm({mode: "onChange"});

    const [tipoDireccion, setTipoDireccion] = useState(CONFIGURACIONES.INIT.TYPE_ADDRESS_CALLE_NUMERO);
    const [tipoZona, setTipoZona] = useState(CONFIGURACIONES.INIT.STRING);

    useEffect(() => {
        setTipoZona(data.tipoZona);
        setTipoDireccion(data.tipoUbicacion);
        Object.entries(data).forEach(([key, value]) => setAddressValue(key, value));
    }, [data]);

    return (
        <div
            className={`modal fade ${show ? "show d-block" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{ background: "rgba(0,0,0,0.5)" }}
        >
            <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
                <form className="modal-content" action="" onSubmit={handleAddressSubmit(onSave)} autoComplete="off">
                    <div className="modal-header">
                        <h5 className="modal-title"> {title}</h5>
                        <button type="button" className="close" onClick={onClose}>
                            <span>&times;</span>
                        </button>
                    </div>

                    <div className="modal-body">
                        <div className="row">
                            <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="tipoZona" className="control-label col-form-label">Tipo de Zona <span className="text-danger">*</span></label>
                                    <select
                                        {...registerAddress("tipoZona", {
                                            required: OWASP.REQUIRED,
                                            onChange:(e) => {
                                                setTipoZona(e.target.value);
                                            },
                                            pattern: {
                                                value: OWASP.VALIDATIONS.GENERAL,
                                                message: OWASP.MESSAGES.DEFAULT
                                            },
                                        })} className="form-control" id="tipoZona"
                                        defaultValue={""}
                                    >
                                        <option value="" disabled>Seleccione</option>
                                        {
                                            CONFIGURACIONES.INIT.LIST.TIPOS_ZONA.map((el, index) => (
                                                <option key={index} value={el.id}>{el.nombre}</option>
                                            ))
                                        }
                                    </select>
                                    <small className="invalid-feedback"> { errorsAddress.tipoZona && errorsAddress.tipoZona.message }</small>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-9">
                                {tipoZona !== CONFIGURACIONES.INIT.TYPE_ZONE_CENTRO_POBLADO && <div className="form-group">
                                    <label htmlFor="nombreZona" className="control-label col-form-label">Nombre de Zona <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="nombreZona"
                                        id="nombreZona"
                                        {...registerAddress("nombreZona", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.GENERAL,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsAddress.nombreZona && errorsAddress.nombreZona.message }</small>
                                </div>}

                                {tipoZona === CONFIGURACIONES.INIT.TYPE_ZONE_CENTRO_POBLADO && <div className="form-group">
                                    <label htmlFor="centroPobladoSelect" className="control-label col-form-label">Nombre <span className="text-danger">*</span></label>
                                    <select
                                        {...registerAddress("centroPobladoSelect", {
                                            required: OWASP.REQUIRED,
                                            onChange:(e) => {
                                                let elemArr = e.target.value.split('@@');
                                                setAddressValue('centroPobladoId', elemArr[0]);
                                                setAddressValue('centroPobladoNombre', elemArr[1]);
                                            }
                                        })} className="form-control" id="tipoZona"
                                        defaultValue={""}
                                    >
                                        <option value="" disabled>Seleccione</option>
                                        {
                                            centrosPoblado.map((el, index) => (
                                                <option key={index} value={`${el.id}@@${el.nombre}`}>{el.nombre}</option>
                                            ))
                                        }
                                    </select>
                                    <small className="invalid-feedback"> { errorsAddress.centroPobladoSelect && errorsAddress.centroPobladoSelect.message }</small>

                                    <input type="hidden" name="centroPobladoId" id="centroPobladoId" 
                                        {...registerAddress("centroPobladoId", {required: OWASP.REQUIRED})} 
                                    />

                                    <input type="hidden" name="centroPobladoNombre" id="centroPobladoNombre" 
                                        {...registerAddress("centroPobladoNombre", {required: OWASP.REQUIRED})} 
                                    />
                                </div>}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="tipoUbicacion" className="control-label col-form-label">Tipo de Dirección <span className="text-danger">*</span></label>
                                    <select
                                        {...registerAddress("tipoUbicacion", {
                                            required: OWASP.REQUIRED,
                                            onChange:(e) => {
                                                setTipoDireccion(e.target.value)
                                            },
                                            pattern: {
                                                value: OWASP.VALIDATIONS.GENERAL,
                                                message: OWASP.MESSAGES.DEFAULT
                                            },
                                        })} className="form-control" id="tipoUbicacion"
                                        defaultValue={""}
                                    >
                                        {
                                            CONFIGURACIONES.INIT.LIST.TIPOS_DIRECCION.map((el, index) => (
                                                <option key={index} value={el.id}>{el.nombre}</option>
                                            ))
                                        }
                                    </select>
                                    <small className="invalid-feedback"> { errorsAddress.tipoUbicacion && errorsAddress.tipoUbicacion.message }</small>
                                </div>
                            </div>
                            
                            {tipoDireccion === CONFIGURACIONES.INIT.TYPE_ADDRESS_CALLE_NUMERO && <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="calle" className="control-label col-form-label">Calle <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="calle"
                                        id="calle"
                                        {...registerAddress("calle", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.GENERAL,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsAddress.calle && errorsAddress.calle.message }</small>
                                </div>
                            </div>}

                            {tipoDireccion === CONFIGURACIONES.INIT.TYPE_ADDRESS_CALLE_NUMERO && <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="numero" className="control-label col-form-label">Número <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="numero"
                                        id="numero"
                                        {...registerAddress("numero", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.GENERAL,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsAddress.numero && errorsAddress.numero.message }</small>
                                </div>
                            </div>}

                            {tipoDireccion === CONFIGURACIONES.INIT.TYPE_ADDRESS_CALLE_NUMERO && <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="interior" className="control-label col-form-label">Interior <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="interior"
                                        id="interior"
                                        {...registerAddress("interior", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.GENERAL,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsAddress.interior && errorsAddress.interior.message }</small>
                                </div>
                            </div>}

                            {tipoDireccion === CONFIGURACIONES.INIT.TYPE_ADDRESS_MANZANA_LOTE && <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="manzana" className="control-label col-form-label">Manzana <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="manzana"
                                        id="manzana"
                                        {...registerAddress("manzana", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.GENERAL,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsAddress.manzana && errorsAddress.manzana.message }</small>
                                </div>
                            </div>}

                            {tipoDireccion === CONFIGURACIONES.INIT.TYPE_ADDRESS_MANZANA_LOTE && <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="lote" className="control-label col-form-label">Lote <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="lote"
                                        id="lote"
                                        {...registerAddress("lote", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_NUMBER_LETTERS,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsAddress.lote && errorsAddress.lote.message }</small>
                                </div>
                            </div>}
                        </div>

                        <div className="row">
                            <div className="col-sm-12 col-md-9">
                                <div className="form-group">
                                    <label htmlFor="referencia" className="control-label col-form-label">Referencia <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="referencia"
                                        id="referencia"
                                        {...registerAddress("referencia", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.GENERAL,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsAddress.referencia && errorsAddress.referencia.message }</small>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-3">
                                <div className="form-group">
                                    <label htmlFor="telefono" className="control-label col-form-label">Teléfono</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="telefono"
                                        id="telefono"
                                        maxLength={8}
                                        {...registerAddress("telefono", {
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                    />
                                    <small className="invalid-feedback"> { errorsAddress.telefono && errorsAddress.telefono.message }</small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <WaveButton type="button" className="btn btn-sm btn-outline-danger" onClick={onClose}>
                            <i className="mdi mdi-arrow-left"></i> Cerrar
                        </WaveButton>
                        {showCreate && <WaveButton type="submit" className="btn btn-sm btn-success waves-effect">
                            <i className="mdi mdi-content-save-settings"></i> Guardar
                        </WaveButton>}
                    </div>
                </form>
            </div>
        </div>
    );
};
export default AddressModal;
